import type { ReactElement } from 'react';

interface CanvasNoteProps {
  readonly children: string;
}

/** 캔버스 위쪽 가운데의 작은 안내 줄 — 곡면 근사 편집·인쇄 영역 없음 같은 상태를 알린다. */
export const CanvasNote = ({ children }: CanvasNoteProps): ReactElement => (
  <p
    role="note"
    className="pointer-events-none absolute top-2 left-1/2 -translate-x-1/2 bg-background/90 px-3 py-1 text-xs whitespace-nowrap text-muted-foreground shadow-sm"
  >
    {children}
  </p>
);
